import React from "react";
import DialogWrapper from "../common/DialogWrapper";
import WarningIcon from "../common/WarningIcon";
import { Typography, Box } from "@mui/material";

type DetectionDownloadConfirmProps = {
  open: boolean;
  onCancel: () => void;
  onDownload: () => void;
};

export default function DetectionDownloadConfirm({
  open,
  onCancel,
  onDownload,
}: DetectionDownloadConfirmProps) {
  return (
    <DialogWrapper
      open={open}
      title={
        <Box display="flex" alignItems="center">
          <Typography variant="h6" ml={1}>
            Heads up! There are unresolved conflicts in your detection database.
          </Typography>
        </Box>
      }
      cancelAction={onCancel}
      okAction={onDownload}
      okButtonContent="Download"
      centerButtons
    >
      <Box>
        <Typography variant="body1" gutterBottom>
          You currently have at least one instance of the same tag attached to multiple animals at
          the same time. Please resolve the conflicts
          <Box component="span" mx={0.5}>
            <WarningIcon tooltip="Conflict" />
          </Box>
          {
            "in the Animals tab before proceeding, otherwise conflicting fields will be <Multiple Animals Matched> in your CSV file."
          }
        </Typography>
      </Box>
    </DialogWrapper>
  );
}
